import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import QrScanner from 'react-qr-scanner';
import './FormPage.css'; // Import your CSS file


const ScanQr = (isAuthenticated) => {
  const [scanResult, setScanResult] = useState(null);
  const [cameraActive, setCameraActive] = useState(false);
  const [error, setError] = useState(null);
  const [redirecting, setRedirecting] = useState(false);
  const navigate = useNavigate();
  // const isAuthenticated = localStorage.getItem("isAuthenticated");
  // console.log("hereee"+ isAuthenticated);

  const handleScan = (data) => {
    if (data) {
      const match = data.text.match(/submit\/(.+)/);
      const extractedPart = match ? match[1] : "No valid part found";
      setScanResult(extractedPart);
      setCameraActive(false); // Stop the camera after scanning
      if (match) {
        setRedirecting(true);
        setTimeout(() => {
          navigate("/form"); // Redirect to the /form page
        }, 2000); // 2-second delay
      }
    }
  };

  const handleError = (err) => {
    console.error(err);
    setError("Error accessing the camera. Please try again.");
  };

  const startCamera = () => {
    setCameraActive(true);
    setError(null); // Clear any previous errors
  };

  return (
    <div className="qr-scanner-container">
      {isAuthenticated ? (
        <div className="qr-scanner-content">
          <button className="qr-scanner-button" onClick={startCamera}>
            Start Camera
          </button>
          {cameraActive && (
            <div className="qr-scanner-camera">
              <QrScanner
                delay={300}
                onError={handleError}
                onScan={handleScan}
                style={{ width: "100%" }}
              />
              {error && <p className="qr-scanner-error">{error}</p>}
            </div>
          )}
          {scanResult && (
            <p className="qr-scanner-result">Scanned Result: {scanResult}</p>
          )}
          {redirecting && (
            <div className="qr-scanner-redirecting">
              <p>Redirecting...</p>
              <div className="qr-scanner-spinner"></div>{" "}
              {/* Add your spinner or loading icon here */}
            </div>
          )}
        </div>
      ) : (
        <p className="qr-scanner-message">Please log in to scan QR codes.</p>
      )}
    </div>
  );
};

export default ScanQr;